module.exports = __webpack_public_path__ + "gray_checklist_report-9bbbcdc447e53c3168a8933177a5a5dd.png";